import React, { useContext } from "react";
import PropTypes from "prop-types";
import { hasAuthorization } from "utils/functions";
import { RightsContext } from "providers/RightsContext";

const AuthorizationWrapper = ({ code, children }) => {
  const rights = useContext(RightsContext);
  const authorized = hasAuthorization(code, rights);

  return authorized ? <>{children}</> : null;
};

AuthorizationWrapper.propTypes = {
  code: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default AuthorizationWrapper;
